import React from "react";
import RatesService from "../services/rates_services";
import firebase from 'firebase/app';
import 'firebase/firestore';
import InputConfigure from "./input_configure";
import Swal from 'sweetalert2'
import swal from 'sweetalert';
import withReactContent from 'sweetalert2-react-content'
import SelectPlace from "./select_place";

const Myswal = withReactContent(Swal);


class ChangeRates extends React.Component {
  state: { rates: firebase.firestore.QueryDocumentSnapshot[], isLoading: boolean } = {
    rates: null,
    isLoading: true,
  }

  componentDidMount() {
    this.getData();
  }

  async updateValue(docId: string, objectName: string, editedField: string, value: string) {
    const currentDocIndex: number = this.state.rates.findIndex(element => element.id === docId);
    const doc = this.state.rates[currentDocIndex].data();
    doc[objectName][editedField] = parseInt(value);

    const response = await swal({
      title: "Estas Segur@",
      text: "Estás por modificar este campo",
      buttons: ["Si, Modificar", "No, Cerrar"]
    });

    if (response === null) {
      swal("Cargando ...");
      await new RatesService().updateRate({ docId, newData: doc, });
      await this.getData();
      swal.close();
    }
  }

  async getData() {
    await new RatesService().getRates().then(rates => {
      this.setState({
        rates: rates.docs,
        isLoading: false,
      })
    })
  }


  async addRate(documentId: string) {

    const response = await swal({
      title: "Cuidado",
      text: "Quieres agregar una nueva area",
      buttons: ["Si, Continuar", "No, Cerrar"]
    });


    if (response === null) {
      swal.close();
      Myswal.fire({
        html: <SelectPlace onChange={async (name) => {

          const tarifaBase = await swal({
            title: "Tarifa Base",
            content: {
              element: "input",
            },
          });
          const costoHora = await swal({
            title: "Costo por Hora",
            content: {
              element: "input",
            },
          });
          const costoKilometro = await swal({
            title: "Costo por Kilometros",
            content: {
              element: "input",
            },
          });

          if (!!name && !!tarifaBase && !!costoHora && !!costoKilometro) {
            swal("Cargando ...");
            await new RatesService().createRate({
              docId: documentId,
              newData: {
                [name]: {
                  COSTO_HORA: parseInt(costoHora),
                  COSTO_POR_KILOMETRO: parseInt(costoKilometro),
                  TARIFA_BASE: parseInt(tarifaBase),
                }
              }
            });
            swal.close();
            Myswal.close();
            await this.getData();
            swal("Creado Correctamente");
          } else {
            swal("No has ingresado los datos correctamente");
          }

        }} />,
        showConfirmButton: false,
      });
    }
  }

  async deleteRate(rateName: string, ratefield: string) {
    const response = await swal({
      title: "Cuidado",
      text: "¿Estás segur@ de eliminar " + ratefield + "?",
      buttons: ["Si, ELiminar", "No, Cerrar"]
    });

    if (response === null) {
      swal("Cargando ...");
      await new RatesService().deleteRate({
        docId: rateName,
        field: ratefield
      });
      await this.getData();
      swal.close();

    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <progress className="progress is-large is-info" max="100" style={{
          width: "60%",
          margin: "auto"
        }} />
      );
    }

    if (this.state.rates.length === 0) {
      return (
        <article className="message is-warning" id="rate-alert">
          <div className="message-header">
            <p>No hay Resultados</p>
            <button className="delete" aria-label="delete" />
          </div>
          <div className="message-body">
            No encontramos resultados para las Ubicaciones y Tarifas
        </div>
        </article>
      );
    }

    return (
      <div id="rates-container">
        {
          this.state.rates.map<JSX.Element>(element => {
            const data = element.data();
            return (
              <div className="container-place" key={element.id}>
                <div className="container-title">
                  <h1 className="title">{element.id}</h1>
                  <button className="button is-success" onClick={() => this.addRate(element.id)}>
                    <span className="icon">
                      <i className="fas fa-plus-circle"></i>
                    </span>
                  </button>

                </div>
                <div className="container-place-items">
                  {
                    data && Object.keys(data).map<JSX.Element>(place => {
                      const values = data[place];
                      return (
                        <div className="card" style={{ padding: 15, margin: 10 }} key={element.id + place}>
                          <div className="container-titles-card-ubication">
                            <h2 className="subtitle">{place}</h2>

                            <button className="button is-danger" onClick={() => this.deleteRate(element.id, place)}>
                              <span className="icon">
                                <i className="fas fa-times"></i>
                              </span>
                            </button>
                          </div>
                          <InputConfigure title="Tarifa Base" text={values.TARIFA_BASE} onUpdate={(response) => {
                            this.updateValue(element.id, place, "TARIFA_BASE", response);
                          }} />
                          <InputConfigure title="Costo por Hora" text={values.COSTO_HORA} onUpdate={(response) => {
                            this.updateValue(element.id, place, "COSTO_HORA", response);
                          }} />
                          <InputConfigure title="Costo por Kilometro" text={values.COSTO_POR_KILOMETRO} onUpdate={(response) => {
                            this.updateValue(element.id, place, "COSTO_POR_KILOMETRO", response);
                          }} />
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default ChangeRates;